import axios from "axios";
import i18n from "../../i18n";

const actions = {
  bulkDeleteInstructions(context, ids) {
    return axios
      .post("instruction/bulk-delete", { ids })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.instructionDeleted"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  bulkMoveInstructions(context, { ids, instructionFolder }) {
    return axios
      .post("instruction/bulk-move", { ids, instructionFolder })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("instructions.bulk.movedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  createInstruction(context, value) {
    return axios
      .post("instruction", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.instructionAdded", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createInstructionProof(context, value) {
    return axios
      .post("instruction/" + value.id + "/proof", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.instructionProofAdded"),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteInstruction(context, val) {
    return axios
      .delete("instruction/" + val.id)
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.instructionDeleted"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateInstruction(context, value) {
    return axios
      .put("instruction/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.instructionChanged", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleInstruction(context, id) {
    return axios
      .get("instruction/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getAllInstructions(context) {
    return axios
      .get("instruction")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPdfInstruction(context, id) {
    return axios
      .get("instruction/" + id + "/pdf")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  moveInstruction(context, { id, instructionFolder }) {
    return axios
      .put("instruction/" + id, { instructionFolder })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("instructions.folder.movedMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
